import React,{useState,useEffect,useRef} from "react";
import {Link,useNavigate} from "react-router-dom";
import Select from "react-select";
/* -- biz9 import start -- */
import {Log,Str,Obj} from "biz9-utility";
import {Field,Message,Title,Type,Url,Project_Table} from "../../../../../constant";
import {App,Data,Dashboard,Event,Image,Style,Service_Industry,Template,Toast_Message,Storage,System,User} from "../../../../../project";
import {Image_Format} from "biz9-image";
import {Data_Logic} from "biz9-data-app";
import {Page_Logic,Portal_Type,Portal_Field,Portal_Url,Portal_Title,Sub_Value_Logic,Portal_Value_Type,Portal_Page,Portal_Remote_Page,Portal_Remote_Data,Portal_Remote_CMS,Portal_Table} from "biz9-portal-app";
/* -- biz9 import end -- */
const App_Edit_Modal = (props) => {
    const [val_app_id,setValAppId] = useState("");
    const [val_title,setValTitle] = useState("");
    const [val_url,setValUrl] = useState("");
    const [val_edit_field,setValEditField] = useState("");
    const [val_sub_page_title,setValSubPageTitle] = useState("");
    //
    const [sel_status,setSelStatus] = useState(null);
    const [sel_user_status,setSelUserStatus] = useState(null);
    //
    const [val_app_link_url,setValAppLinkUrl] = useState("");
    const [sel_app_link_type,setSelAppLinkType] = useState(null);
    const [link,setLink] = useState(Data_Logic.get(Portal_Table.LINK,0));
    const [app,setApp] = useState(Data_Logic.get(Project_Table.APP,0));

    useEffect(() => {
            if(props){
                bind_items(props);
            }
            },[props]);

    async function bind_items(props){
        // -- app --
        setApp(props.app);
        // -- form title --
        setValSubPageTitle("Edit App");
        // -- title --
        setValTitle(props.app.title);
        // -- url --
        setValUrl(props.app.url);
   };
    async function post_field(field,value,option){
        let item = Data_Logic.get(Project_Table.APP,app.id);
        if(!value){
            value = '';
        }
        if(field == Portal_Field.TITLE && !Str.check_is_null(item[Portal_Field.TITLE])){
            item[Portal_Field.TITLE_URL] = Str.get_title_url(value);
        }
        option = option ? option : {required:false,success_message:''};
        if(value.trim() === '' && option.required) {
                  Toast_Message.error(Str.get_title(field) + " " +Message.INPUT_REQUIRED);
        }else{
            Toast_Message.loading(Message.SAVING);
            item[field] = value;
            console.log('my_item',item);
            const [response,data] = await Portal_Remote_Data.post(App.get_url(Portal_Url.DATA_POST),Portal_Table.APP,item);
            props.onUpdate(field,value);
            if(!option.success_message){
                Toast_Message.success(response.message);
            }else{
                Toast_Message.success(option.success_message);
            }
        }
    };
    const updateStatus = (selectedOption) => {
        setSelStatus(selectedOption);
    };
    const updateUserStatus = (selectedOption) => {
        setSelUserStatus(selectedOption);
    };
    const updateValTitle = (event) => {
        setValTitle(event.target.value);
    };
    const updateValUrl = (event) => {
        setValUrl(event.target.value);
    };
    const updateValLinkType = (selectedOption) => {
        setSelAppLinkType(selectedOption);
    };
    const updateValAppLinkUrl = (event) => {
        setValAppLinkUrl(event.target.value);
    };
return (
        <>
        <div className="modal new-modal fade" id="app_edit_modal" data-keyboard="false" data-backdrop="static">
        <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
        <div className="modal-header">
        <h5 className="modal-title">{val_sub_page_title}</h5>
        <button type="button" className="close-btn" data-bs-dismiss="modal">
        <span>×</span>
        </button>
        </div>
        <div className="modal-body">
        <div className="row">
        <div className="col-md-12">
        <div className="amt-wrap">
<div className="form-wrap">
<label className="form-label mb-1 fw-medium text-dark">
Title
</label>
<input value={val_title} onChange={updateValTitle} type="text" className="form-control" onBlur={() => post_field(Portal_Field.TITLE,val_title,{required:false})} />
</div>
<div  className="form-wrap">
<label className="form-label mb-1 fw-medium text-dark">
Url
</label>
<input value={val_url} onChange={updateValUrl} type="text" className="form-control" onBlur={() => post_field(Field.URL,val_url,{required:false})} />
</div>
</div>
</div>
<div className="col-md-12">
<Link hidden={true} to="#"  data-bs-dismiss="modal" className="btn btn-primary w-100">
Save
</Link>
</div>
</div>
</div>
</div>
</div>
</div>
</>
);
};
export default App_Edit_Modal;
